import React from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Separator } from "@/components/ui/separator";
import {
  HelpCircle,
  Search,
  MessageCircle,
  ShieldCheck,
  Mail,
} from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const Help = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />

      <main className="flex-grow pt-16">
        {/* Hero section */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-brand-50 to-white"></div>
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
            <div className="text-center max-w-3xl mx-auto">
              <h1 className="text-3xl md:text-4xl font-bold mb-6">
                Qendra e Ndihmës
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                Gjeni përgjigje për pyetjet tuaja dhe mësoni se si të përdorni
                TreguIm në mënyrën më të mirë.
              </p>
              <div className="max-w-md mx-auto">
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Search className="h-5 w-5 text-gray-400" />
                  </div>
                  <input
                    type="text"
                    className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-full bg-white focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                    placeholder="Kërko në qendrën e ndihmës..."
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ section */}
        <section className="py-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl font-bold mb-8 text-center">
                Pyetjet më të Shpeshta
              </h2>

              <Accordion
                type="single"
                collapsible
                className="bg-white rounded-xl shadow-sm border border-gray-100 p-4"
              >
                <AccordionItem value="item-1">
                  <AccordionTrigger className="text-left py-4 px-2">
                    Si mund të krijoj një llogari në TreguIm?
                  </AccordionTrigger>
                  <AccordionContent className="px-2 pb-4 pt-1 text-gray-600">
                    Krijimi i një llogarie në TreguIm është shumë i thjeshtë.
                    Klikoni në butonin "Regjistrohu" në faqen kryesore,
                    plotësoni formularin me të dhënat tuaja, konfirmoni email-in
                    dhe llogaria juaj do të jetë aktive.
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="item-2">
                  <AccordionTrigger className="text-left py-4 px-2">
                    Si mund të publikoj një shpallje të re?
                  </AccordionTrigger>
                  <AccordionContent className="px-2 pb-4 pt-1 text-gray-600">
                    Pas hyrjes në llogari, klikoni në butonin "Krijo Shpallje"
                    në faqen kryesore ose në profilin tuaj. Plotësoni formularin
                    me të dhënat e artikullit tuaj, ngarkoni disa foto cilësore
                    dhe publikoni. Mbani mend se ju nevojiten kredite për të
                    publikuar shpallje të reja.
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="item-3">
                  <AccordionTrigger className="text-left py-4 px-2">
                    Çfarë janë kreditet dhe si funksionojnë?
                  </AccordionTrigger>
                  <AccordionContent className="px-2 pb-4 pt-1 text-gray-600">
                    Kreditet janë njësi që përdoren për të publikuar shpallje në
                    TreguIm. Çdo përdorues i ri merr 25 kredite falas plus 25
                    dhuratë nga platforma. Pas përdorimit të tyre, mund të blini
                    kredite shtesë me çmime të përballueshme. Një kredit ju
                    lejon të publikoni një shpallje të re. Kreditet nuk skadojnë
                    kurrë.
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="item-4">
                  <AccordionTrigger className="text-left py-4 px-2">
                    Si funksionojnë pagesat në TreguIm?
                  </AccordionTrigger>
                  <AccordionContent className="px-2 pb-4 pt-1 text-gray-600">
                    TreguIm është një platformë që lidh blerësit dhe shitësit.
                    Shumica e transaksioneve bëhen me para në dorë kur blerësi
                    dhe shitësi takohen. Ne rekomandojmë që takimet të bëhen në
                    vende publike për sigurinë tuaj. Për blerjen e krediteve ose
                    shërbimet premium, TreguIm pranon pagesa me kartë krediti
                    dhe PayPal.
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="item-5">
                  <AccordionTrigger className="text-left py-4 px-2">
                    Si mund të komunikoj me një shitës?
                  </AccordionTrigger>
                  <AccordionContent className="px-2 pb-4 pt-1 text-gray-600">
                    Pasi gjeni një artikull që ju intereson, mund të kontaktoni
                    shitësin duke klikuar butonin "Dërgo Mesazh" në faqen e
                    detajeve të artikullit. Pastaj mund të vazhdoni bisedën në
                    seksionin e mesazheve të platformës. Sigurohuni që të jeni
                    të sjellshëm dhe të qartë në komunikimet tuaja.
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="item-6">
                  <AccordionTrigger className="text-left py-4 px-2">
                    Si mund të raportoj një shpallje apo përdorues problematik?
                  </AccordionTrigger>
                  <AccordionContent className="px-2 pb-4 pt-1 text-gray-600">
                    Nëse vëreni një shpallje që shkel kushtet tona të përdorimit
                    ose hasni një përdorues problematik, mund ta raportoni duke
                    klikuar butonin "Raporto" në faqen përkatëse. Ekipi ynë do
                    të rishikojë raportin tuaj dhe do të marrë masa të
                    përshtatshme. Gjithashtu mund të na kontaktoni drejtpërdrejt
                    përmes faqes së kontaktit.
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </section>

        {/* Help topics section */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold mb-12 text-center">
              Temat e Ndihmës
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
              <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow">
                <div className="flex flex-col items-center text-center">
                  <div className="bg-brand-50 p-4 rounded-full mb-4">
                    <HelpCircle className="h-8 w-8 text-brand-500" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3">
                    Udhëzimet për Përdoruesit e Rinj
                  </h3>
                  <p className="text-gray-600 mb-4">
                    Mësoni hapat bazë për të filluar me TreguIm, nga krijimi i
                    llogarisë deri tek publikimi i shpalljeve tuaja të para.
                  </p>
                  <Button variant="outline" className="mt-auto">
                    Lexo më shumë
                  </Button>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow">
                <div className="flex flex-col items-center text-center">
                  <div className="bg-brand-50 p-4 rounded-full mb-4">
                    <MessageCircle className="h-8 w-8 text-brand-500" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3">
                    Komunikimet dhe Mesazhet
                  </h3>
                  <p className="text-gray-600 mb-4">
                    Këshilla për komunikim efektiv me blerësit dhe shitësit, dhe
                    si të përdorni sistemin e mesazheve.
                  </p>
                  <Button variant="outline" className="mt-auto">
                    Lexo më shumë
                  </Button>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow">
                <div className="flex flex-col items-center text-center">
                  <div className="bg-brand-50 p-4 rounded-full mb-4">
                    <ShieldCheck className="h-8 w-8 text-brand-500" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3">
                    Siguria dhe Privatësia
                  </h3>
                  <p className="text-gray-600 mb-4">
                    Informacione të rëndësishme për të mbajtur të sigurt
                    llogarinë tuaj dhe transaksionet në TreguIm.
                  </p>
                  <Button
                    variant="outline"
                    className="mt-auto"
                    onClick={() => navigate("/safety")}
                  >
                    Lexo më shumë
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact us section */}
        <section className="py-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto bg-brand-50 rounded-xl p-8 border border-brand-100">
              <div className="flex flex-col md:flex-row items-center justify-between">
                <div className="md:w-2/3 mb-6 md:mb-0">
                  <div className="flex items-center mb-4">
                    <Mail size={24} className="text-brand-500 mr-3" />
                    <h2 className="text-2xl font-bold">Nuk gjeni përgjigje?</h2>
                  </div>
                  <p className="text-gray-600 mb-2">
                    Nëse nuk keni gjetur përgjigjen që po kërkoni, mos hezitoni
                    të na kontaktoni drejtpërdrejt. Ekipi ynë i mbështetjes
                    është këtu për t'ju ndihmuar.
                  </p>
                </div>

                <div className="md:w-1/3 text-center">
                  <Button
                    className="bg-brand-500 hover:bg-brand-600"
                    onClick={() => navigate("/contact")}
                  >
                    Na kontaktoni
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Help;
